import { render, staticRenderFns } from "./Contact.html?vue&type=template&id=936d29d6&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./Contact.scss?vue&type=style&index=0&id=936d29d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936d29d6",
  null
  
)

export default component.exports